import React, { Component } from "react";
import IntelligentHeader from "../IntelligentAllMajorModal/components/IntelligentHeader";
import IntelligentAdvanceMajorContent from "./components/IntelligentAdvanceMajorContent";
import "./style.css";
import "../../../../../index.css";
class IntelligentAdvanceMajorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      visible,
      handleVisibleAdvanceMajorModal,
      advanceMajorData,
      advanceYear,
    } = this.props;
    return (
      <div
        className={
          visible === true
            ? "intelligentAdvanceMajorModal_box"
            : "intelligentAdvanceMajorModal_box display_none"
        }
      >
        <IntelligentHeader
          type="advance"
          handleVisible={handleVisibleAdvanceMajorModal}
        ></IntelligentHeader>
        <div style={{height:39}}></div>
        <div className="intelligentAdvanceMajorModal_header_box">
          {advanceYear}年浙江省普通高校招生普通类提前录取各专业录取情况
        </div>
        <table style={{position:'unset'}} className="intelligentDataHead_table_box">
        <tbody>
          <tr>
            <td
              style={{
                borderLeft: 0,
                width: "47%",
                textAlign: "left",
                paddingLeft: "5px",
              }}
            >
              院校代码、院校（专业）名
            </td>
            <td style={{ width: "10%" }}>录取人数</td>
            <td style={{ width: "5%" }}>学制</td>
            <td style={{ width: "10%" }}>平均分</td>
            <td style={{ width: "10%" }}>最低分</td>
            <td style={{ borderRight: 0, width: "18%" }}>位次号</td>
          </tr>
        </tbody>
      </table>
        {advanceMajorData != null
          ? advanceMajorData.map((item, index) => {
              return (
                <IntelligentAdvanceMajorContent
                  key={index}
                  item={item}
                ></IntelligentAdvanceMajorContent>
              );
            })
          : ""}
      </div>
    );
  }
}

export default IntelligentAdvanceMajorModal;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentAdvanceMajorModal/index.js